<template>
  <div>
    <!-- <v-text-field
      outlined
      class="mx-4"
      placeholder="Search.."
      v-model="searchQuery"
    /> -->
    <v-list class="list">
      <v-lazy v-for="item in users" :key="item.id">
        <v-list-item-group :value="listValue" multiple @change="onListChange">
          <v-list-item
            :value="item.id"
            :inactive="readonly"
            @click="goToProfile(item)"
          >
            <template v-slot:default="{ active }">
              <profile-picture-avatar
                class="mr-4 my-2"
                size="46"
                :profile="item.profile"
              >
              </profile-picture-avatar>

              <v-list-item-content class="black--text">
                <v-list-item-title>{{ item.profile.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action v-if="!readonly">
                <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-divider
            class="border-bottom grey--text text--lighten-2 px-0 mx-4"
          ></v-divider>
        </v-list-item-group>
      </v-lazy>

      <v-list-item-group v-intersect="onIntersect"></v-list-item-group>

      <v-list-item-group v-if="loading">
        <v-list-item>
          <v-progress-circular
            class="mx-auto"
            indeterminate
          ></v-progress-circular>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ProfilePictureAvatar from "./ProfilePictureAvatar.vue";

export default {
  components: { ProfilePictureAvatar },

  props: {
    value: {
      type: Array,
      required: true,
    },
    selectAll: {
      type: Boolean,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    readonly: {
      type: Boolean,
    },
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    users() {
      if (this.readonly) return this.$store.state.groups.groupParticipants;
      if (this.isEditing) return this.$store.state.groups.groupUsers;
      return this.$store.state.Auth.followers;
    },

    listValue() {
      if (this.selectAll) return this.users.map((u) => u.id);
      return this.value;
    },

    searchQuery: {
      get() {
        if (this.isEditing) {
          return this.$store.state.groups.groupUsersMeta.search_query;
        } else {
          return this.$store.state.Auth.followersMeta.search_query;
        }
      },

      set(val) {
        if (this.isEditing) {
          this.$store.commit("groups/setGroupUsersMetaSearchQuery", val);
        } else {
          this.$store.commit("Auth/setFollowersMetaSearchQuery", val);
        }
        // this.fetch();
      },
    },
  },

  watch: {
    searchQuery(newValue, oldValue) {
      console.log("searchQuery: ", newValue, oldValue);
      this.fetch();
    },
  },

  methods: {
    onListChange(value) {
      if (!this.readonly) this.$emit("input", value);
    },

    async fetch() {
      this.loading = true;
      if (this.readonly) {
        await this.$store.dispatch("groups/fetchGroupParticipants");
      } else if (this.isEditing) {
        await this.$store.dispatch("groups/fetchGroupUsers");
      } else {
        await this.$store.dispatch("Auth/fetchFollowers");
      }
      this.loading = false;
    },

    onIntersect(entries) {
      let hasMorePage = this.$store.getters["Auth/followersHasMorePage"];
      if (this.readonly)
        hasMorePage =
          this.$store.getters["groups/groupParticipantsHasMorePage"];
      if (this.isEditing)
        hasMorePage = this.$store.getters["groups/groupUsersHasMorePage"];

      if (entries[0].isIntersecting && hasMorePage && !this.loading) {
        return this.fetch();
      }
    },

    goToProfile(user) {
      if (!this.readonly) return;
      this.$router.push({
        name: "OthersProfilePage",
        params: {
          id: user.id,
          name: user.profile.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.list {
  max-height: 30vh;
  overflow-y: auto;
}
</style>
